import { Teaser as t } from '@xprog/prensa/types'

export const TeaserColumnist: t.TeaserProps = {
  css: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderRadius: '$alternative',
    p: '$0',
    pt: '$0',
    mb: '$4',
    '.TeaserImage img': {
      borderRadius: '$circle'
    },
    '.TeaserImageContainer': {
      borderRadius: '$circle',
      maxWidth: '80px'
    },
    '.TeaserWrap': {
      pb: '$4',
      pl: '$4',
      pr: '$4',
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubject': {
      width: '100%'
    },
    '.TeaserSubjectText': {
      textAlign: 'left',
      color: '#4C362B',
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 500,
      mb: '$1'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      width: '100%'
    },
    '.TeaserTitleText': {
      fontSize: '16px',
      fontWeight: 400,
    },
  },
  className: 'TeaserColumnist',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subjectTextVariant: 'subject-default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-sm'
}